import { Color, Type } from '../../ions';
import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tag = styled.p`
  font-family: ${(props) => props.font || 'Noto Sans KR'};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : '0px')};
  margin-right: ${(props) => (props.mr ? `${props.mr}px` : '0px')};
  margin-left: ${(props) => (props.ml ? `${props.ml}px` : '0px')};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : '0px')};
  color: ${(props) => {
    switch (props.color) {
      case Color.BASIC:
        return '#333';
      case Color.BLACK:
        return '#000';
      case Color.SUB:
        return '#777';
      case Color.PLACEHOLDER:
        return '#999';
      case Color.ERROR:
      case Color.TEXT_BUTTON:
        return '#FF6F61';
      case Color.DISABLED:
        return '#ddd';
      case Color.BLUE:
        return '#6191ff';
      case Color.WHITE:
        return '#ffffff';
      default:
        return props.color;
    }
  }};
  ${(props) => {
    switch (props.type) {
      case Type.H1:
        return `
                  font-size: 20px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.35;
                  letter-spacing: -0.8px;
                `;
      case Type.H2:
        return `
                  font-size: 15px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.8;
                  letter-spacing: -0.75px;
                `;
      case Type.H3:
        return `
                  font-size: 15px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 2;
                  letter-spacing: -1px;
                `;
      case Type.P:
        return `
                  font-size: 15px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: -0.8px;
                `;
      case Type.DESCRIPTION:
        return `
                  font-size: 14px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  letter-spacing: -0.8px;
                `;
      case Type.SUB:
        return `
                  font-size: 13px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: -0.74px;
                `;
    }
  }}

  ${(props) => props.bold && `font-weight: 600;`}
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight};`}

  transition: all 0.3s;
  ${(props) =>
    props.chip &&
    `
    background-color: ${props.chip};
    padding: 0 6px;
    display: inline-block;
    border-radius: 3px;
  `}
  ${(props) => props.lineHeight && `line-height: ${props.lineHeight};`}

  word-break: break-all;
  word-wrap: break-word;
`;

class Typography extends PureComponent {
  static defaultProps = {
    color: Color.BASIC,
    type: Type.P,
    bold: false,
    font: null,
    danger: false,
  };
  render() {
    const { children, danger, ...props } = this.props;
    if (!danger) {
      return <Tag {...props}>{children}</Tag>;
    } else {
      return <Tag {...props} dangerouslySetInnerHTML={{ __html: children }} />;
    }
  }
}

Typography.propTypes = {
  color: PropTypes.string,
  type: PropTypes.string,
  bold: PropTypes.bool,
  font: PropTypes.string,
  fontWeight: PropTypes.number,
  danger: PropTypes.bool,
  chip: PropTypes.string,
};

export default Typography;
